import { createContext } from '@chakra-ui/react-utils';
import type { FormikHandlers } from 'formik';

import type { useFeatureFlagsQuery } from 'modules/common/drawers/featureFlagDrawer/data/hooks';

export type FeatureFlagFormContextProps = {
  featureFlagsQueryResult: ReturnType<typeof useFeatureFlagsQuery>;
  isSubmitting: boolean;
  handleSubmit: FormikHandlers['handleSubmit'];
};

const [FeatureFlagFormContextProvider, useFeatureFlagFormContext] =
  createContext<FeatureFlagFormContextProps>({
    name: 'FeatureFlagFormContext',
    errorMessage:
      'useFeatureFlagFormContext: `context` is undefined. Seems you used the useFeatureFlagFormContext hook outside of a FeatureFlagFormContextProvider. One way this can happen is by rendering a FeatureFlagForm without wrapping it in a FeatureFlagFormWrapper.',
  });

export { FeatureFlagFormContextProvider, useFeatureFlagFormContext };
